import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export function ButtonLoadMore({
  sx,
  total,
  showing,
  loading,
  perPage = 20,
  otherCondition = true,
  ...other
}) {
  const { t } = useTranslate();

  if (!(total > showing && showing >= perPage && otherCondition)) return null;

  return (
    <Box sx={[{ display: 'grid', placeItems: 'center' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Button
        size="large"
        disabled={loading}
        variant="outlined"
        endIcon={!loading && <Iconify icon="eva:arrow-ios-downward-fill" width={24} />}
        startIcon={loading && <Iconify icon="svg-spinners:12-dots-scale-rotate" width={24} />}
        sx={{ width: { xs: 1, md: 320 } }}
        {...other}
      >
        {t(loading ? 'Loading...' : 'Show more')}
      </Button>
    </Box>
  );
}
